import React, { useEffect } from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { ClientDashboard } from "../../client/ClientDashboard"
import { AdminDashboard } from "../../admin/AdminDashboard"
import { ManagerDashboard } from "../../manager/ManagerDashboard"

export const MainPage = () => {
  const { userStore } = useStore()

  useEffect(() => {
    if (!userStore.getToken) {
      window.location.href = "/"
    }
  }, [])

  if (userStore.isClient) {
    return <ClientDashboard />
  } else if (userStore.isAdmin) {
    return <AdminDashboard />
  } else if (userStore.isManager) {
    return <ManagerDashboard />
  } else return <></>
}
